import { campoDeveSerMaiorQueZero, campoObrigatorio, campoInvalido } from 'helpers/Constantes/Mensagens'
import { parseISO, isValid } from 'date-fns'

export type DadosParcela = {
  valorParcela: string | number
  numeroParcelas: string | number
  condicionante: string
  dataBasePrimeiraParcela: Date | null
  colchaoPrimeiraParcela: string | number
  indiceCorrecao: string
  taxaCorrecao: string | number
  condicionanteDataBaseCorrecao: string
  dataBaseCorrecao: Date | null
}

export const dadosParcelaValorDefault = {
  valorParcela: '',
  numeroParcelas: '',
  condicionante: '',
  dataBasePrimeiraParcela: null,
  colchaoPrimeiraParcela: '',
  indiceCorrecao: '',
  taxaCorrecao: '',
  condicionanteDataBaseCorrecao: '',
  dataBaseCorrecao: null
} as DadosParcela

export class ValidacaoDadosParcela {
  valorParcela: string
  numeroParcelas: string
  condicionante: string
  dataBasePrimeiraParcela: string
  indiceCorrecao: string
  taxaCorrecao: string
  condicionanteDataBaseCorrecao: string
  dataBaseCorrecao: string

  constructor(
    valorParcela = '',
    numeroParcelas = '',
    condicionante = '',
    dataBasePrimeiraParcela = '',
    indiceCorrecao = '',
    taxaCorrecao = '',
    condicionanteDataBaseCorrecao = '',
    dataBaseCorrecao = ''
  ) {
    this.valorParcela = valorParcela
    this.numeroParcelas = numeroParcelas
    this.condicionante = condicionante
    this.dataBasePrimeiraParcela = dataBasePrimeiraParcela
    this.indiceCorrecao = indiceCorrecao
    this.taxaCorrecao = taxaCorrecao
    this.condicionanteDataBaseCorrecao = condicionanteDataBaseCorrecao
    this.dataBaseCorrecao = dataBaseCorrecao
  }

  validarInputUsuario(inputUsuario: string): string {
    let error = ''

    if (parseFloat(inputUsuario) === 0) error = campoDeveSerMaiorQueZero

    if (inputUsuario === '') error = campoObrigatorio

    return error
  }

  validarCampoObrigatorio(inputUsuario: string): string {
    let error = ''

    if (inputUsuario === '') error = campoObrigatorio

    return error
  }

  validarData(valor: Date | null): string {
    let error = ''

    if (valor === null) {
      error = campoObrigatorio
    } else if (valor < parseISO('1900-01-01 00:00:00') || !isValid(valor)) {
      error = campoInvalido
    }

    return error
  }
}
